import React, { useRef } from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import "./RelatorioObjetivosQualidadePrint.css";

const ID_QUADRO_IMPRESSAO = "quadro-impressao-objetivos-qualidade";
const LARGURAS_COLUNAS = ["4%", "10%", "17%", "11%", "13%", "16%", "8%", "8%", "8%", "5%"];

const ESTILOS_IMPRESSAO_OBJETIVOS_QUALIDADE = `
  @page { size: A4 landscape; margin: 10mm; }
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; background: #fff; color: #071b31; font-family: Arial, sans-serif; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .pagina-pdf-objetivos-qualidade { width: 100%; }
  .cabecalho-pdf-objetivos-qualidade, .tabela-pdf-objetivos-qualidade { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .cabecalho-pdf-objetivos-qualidade td { border: 1px solid #153d64; padding: 6px; text-align: center; }
  .cabecalho-pdf-objetivos-qualidade td:first-child { width: 28mm; }
  .cabecalho-pdf-objetivos-qualidade td:last-child { width: 43mm; }
  .cabecalho-pdf-objetivos-qualidade img { max-width: 26mm; max-height: 15mm; }
  .cabecalho-pdf-objetivos-qualidade strong, .cabecalho-pdf-objetivos-qualidade span { display: block; }
  .cabecalho-pdf-objetivos-qualidade td:nth-child(2) strong { color: #0b4b78; font-size: 16px; }
  .cabecalho-pdf-objetivos-qualidade span { margin-top: 3px; font-size: 12px; }
  .cabecalho-pdf-objetivos-qualidade .identificacao-pdf-objetivos-qualidade { padding: 0; }
  .cabecalho-pdf-objetivos-qualidade .identificacao-pdf-objetivos-qualidade div { padding: 5px 3px; font-size: 12px; }
  .cabecalho-pdf-objetivos-qualidade .identificacao-pdf-objetivos-qualidade div + div { border-top: 1px solid #153d64; }
  .periodo-pdf-objetivos-qualidade { margin: 4mm 0; padding: 2.5mm; border: 1px solid #8da1b5; color: #0b4774; font-size: 12px; font-weight: 700; text-align: center; }
  .tabela-pdf-objetivos-qualidade { font-size: 12px; }
  .tabela-pdf-objetivos-qualidade th, .tabela-pdf-objetivos-qualidade td { border: 1px solid #777; padding: 4px 3px; text-align: center; vertical-align: middle; overflow-wrap: anywhere; white-space: pre-line; }
  .tabela-pdf-objetivos-qualidade th { background: #0b4774; color: #fff; font-size: 12px; }
  .tabela-pdf-objetivos-qualidade th.cabecalho-estrategico-objetivos-qualidade { background: #1e1156; }
  .tabela-pdf-objetivos-qualidade thead { display: table-header-group; }
  .tabela-pdf-objetivos-qualidade tr { break-inside: avoid; page-break-inside: avoid; }
  .tabela-pdf-objetivos-qualidade tbody tr:nth-child(even) { background: #f4f7f9; }
`;

const valor = (conteudo) => String(conteudo ?? "").trim() || "-";

function imprimirObjetivosQualidade(elemento, nomeArquivo) {
  if (!elemento) return;

  document.getElementById(ID_QUADRO_IMPRESSAO)?.remove();
  const quadroImpressao = document.createElement("iframe");
  quadroImpressao.id = ID_QUADRO_IMPRESSAO;
  quadroImpressao.title = "Impressão dos Objetivos da Qualidade";
  Object.assign(quadroImpressao.style, { position: "fixed", right: "0", bottom: "0", width: "1px", height: "1px", border: "0", opacity: "0", pointerEvents: "none" });
  document.body.appendChild(quadroImpressao);

  const janelaImpressao = quadroImpressao.contentWindow;
  const documentoImpressao = quadroImpressao.contentDocument;
  documentoImpressao.open();
  documentoImpressao.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${nomeArquivo}</title><style>${ESTILOS_IMPRESSAO_OBJETIVOS_QUALIDADE}</style></head><body></body></html>`);
  documentoImpressao.close();
  documentoImpressao.body.appendChild(elemento.cloneNode(true));

  const imagens = Array.from(documentoImpressao.images);
  Promise.all(imagens.map((imagem) => imagem.complete ? Promise.resolve() : new Promise((resolve) => {
    imagem.addEventListener("load", resolve, { once: true });
    imagem.addEventListener("error", resolve, { once: true });
  }))).then(() => {
    janelaImpressao.onafterprint = () => quadroImpressao.remove();
    janelaImpressao.focus();
    janelaImpressao.print();
  });
}

export default function RelatorioObjetivosQualidadePrint({ cadastro, onVoltar }) {
  const paginaRef = useRef(null);
  const objetivos = Array.isArray(cadastro?.objetivos) ? cadastro.objetivos : [];
  const nomeArquivo = `RQ-1.9-OBJETIVOS-DA-QUALIDADE-${valor(cadastro?.periodo)}-REV-${valor(cadastro?.revisao)}`;
  useNomeArquivoPdf(nomeArquivo);

  if (!cadastro) return null;

  return (
    <div className="relatorio-objetivos-qualidade-print">
      <div className="acoes-relatorio-objetivos-qualidade">
        <button type="button" onClick={onVoltar}>Voltar</button>
        <button type="button" className="botao-pdf-objetivos-qualidade" onClick={() => imprimirObjetivosQualidade(paginaRef.current, nomeArquivo)}>Salvar como PDF</button>
      </div>
      <main ref={paginaRef} className="pagina-pdf-objetivos-qualidade">
        <table className="cabecalho-pdf-objetivos-qualidade">
          <tbody>
            <tr>
              <td><LogoRelatorio alt="Logo da empresa" /></td>
              <td><strong>OBJETIVOS DA QUALIDADE</strong><span>Sistema de Gestão da Qualidade</span></td>
              <td className="identificacao-pdf-objetivos-qualidade"><div><strong>RQ 1.9</strong></div><div>Revisão {valor(cadastro.revisao)}</div><div>{valor(cadastro.atualizadoEmDocumento)}</div></td>
            </tr>
          </tbody>
        </table>

        <div className="periodo-pdf-objetivos-qualidade">Período: {valor(cadastro.periodo)}</div>

        <table className="tabela-pdf-objetivos-qualidade">
          <colgroup>{LARGURAS_COLUNAS.map((largura, indice) => <col key={indice} style={{ width: largura }} />)}</colgroup>
          <thead>
            <tr>
              <th rowSpan={2} className="cabecalho-estrategico-objetivos-qualidade">Item</th>
              <th rowSpan={2} className="cabecalho-estrategico-objetivos-qualidade">Perspectiva</th>
              <th rowSpan={2} className="cabecalho-estrategico-objetivos-qualidade">Objetivo Estratégico</th>
              <th rowSpan={2} className="cabecalho-estrategico-objetivos-qualidade">Responsável</th>
              <th colSpan={3}>Monitoramento</th>
              <th colSpan={3}>Resultado do Período</th>
            </tr>
            <tr>
              <th>Indicador</th>
              <th>Como medir</th>
              <th>Periodicidade</th>
              <th>Valor executado</th>
              <th>Valor realizado</th>
              <th>% concluído</th>
            </tr>
          </thead>
          <tbody>
            {objetivos.map((objetivo, indice) => (
              <tr key={`${objetivo.item || "item"}-${indice}`}>
                <td>{valor(objetivo.item || indice + 1)}</td>
                <td>{valor(objetivo.perspectiva)}</td>
                <td>{valor(objetivo.objetivoEstrategico)}</td>
                <td>{valor(objetivo.responsavel)}</td>
                <td>{valor(objetivo.indicador)}</td>
                <td>{valor(objetivo.comoMedir)}</td>
                <td>{valor(objetivo.periodicidade)}</td>
                <td>{valor(objetivo.valorExecutado)}</td>
                <td>{valor(objetivo.valorRealizado)}</td>
                <td>{valor(objetivo.percentualConcluido)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>
    </div>
  );
}
